import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { of } from 'rxjs/observable/of';
import { SUCCESS, DANGER, WARNING, RemoveAction } from '../alert/alert.actions';

@Injectable()
export class AlertEffects {
  // Listen for the 'LOGIN' action
  @Effect() login$: Observable<Action> = this.actions$
    .ofType(SUCCESS, DANGER, WARNING)
    .map(action => new RemoveAction());

  constructor(
    private actions$: Actions
  ) {}
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/effects/alert.ts